import React from 'react';

const CheckButton = ({
    id = 'check-button',
    initialValue = false,
    value,
    onClick,
    disabled = false,
    activeStyle,
    inactiveStyle,
    disabledStyle,
    style,
    ...props
}) => {
    const handleClick = () => {
        if (typeof onClick === 'function' && !disabled) onClick(id, !value);
    };

    if (value === undefined) value = initialValue;

    activeStyle = {
        backgroundColor: 'rgb(65,65,65)',
        color: 'rgb(255,255,255)',
        ...style,
        ...activeStyle
    };

    inactiveStyle = {
        backgroundColor: 'rgb(255,255,255)',
        color: 'rgb(65,65,65)',
        ...style,
        ...inactiveStyle
    };

    style = {
        boxSizing: 'border-box',
        width: 'max-content',
        fontSize: 14,
        textAlign: 'center',
        border: '2px solid rgba(178,178,178,1)',
        borderRadius: 2,
        padding: '3px 6px',
        fontFamily: 'Roboto',
        fontWeight: 500,
        userSelect: 'none',
        MsUserSelect: 'none',
        MozUserSelect: 'none',
        KhtmlUserSelect: 'none',
        WebkitUserSelect: 'none',
        WebkitTouchCallout: 'none',
        cursor: disabled ? 'default' : 'pointer',
        ...style,
        ...(value ? activeStyle : inactiveStyle),
        ...(disabled ? disabledStyle : undefined)
    };

    props = {
        ...props,
        id: id,
        onClick: disabled ? undefined : handleClick,
        style: style
    };

    return <div {...props} />;
};

export default CheckButton;
